import { NgModule } from '@angular/core';

import { SessiebeheerResource } from './sessiebeheer.resource';

/**
 * @ngdoc module
 * @name SessiebeheerModule
 * @description interface to apic-sessiebeheer
 **/
@NgModule({
    providers: [SessiebeheerResource]
})
export class SessiebeheerModule {}
